// extracted by mini-css-extract-plugin
export default {"caption":"IconButton_caption__o44V1","svgIcon":"IconButton_svgIcon__g2Z7e"};